// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prop-65[data-v-2dd4fdb5] svg{box-shadow:1px 1px 5px 0 #0009;max-height:56px;max-width:300px;width:100%}@media (min-width:1024px){.has-video[data-v-2dd4fdb5]{min-height:355px}}@media (min-width:1280px){.has-video[data-v-2dd4fdb5]{min-height:427px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
